/**
 * Domain — Snowy/LLM-first concept introduced 2026-04-24.
 *
 * A Domain is a self-contained bundle of prompts, tools, evals, fixtures,
 * and eval-harness code scoped to a single category of bot work.
 *
 * This enum is the LLM-first equivalent of the legacy NLP `CoreType` enum
 * (libs/types/src/Core/Core.Interfaces.ts) and is intentionally separate from it.
 * Legacy NLP is not modified as part of the Domain architecture work.
 *
 * See docs/snowy/plans/2026-04-24-domain-architecture-implementation-plan.md
 */
export enum Domain {
  Storage = "storage"
}

/**
 * Default domain used when no explicit domain is provided.
 * Guarantee: this value always exists in the Domain enum.
 */
export const DEFAULT_DOMAIN: Domain = Domain.Storage;
